<div class="numpad-container">
    <ms-incremental-stakes *ngIf="numpadService.keypadOptions.showIncrementalStakes"></ms-incremental-stakes>
    <ms-numpad-keys class="numpad__numpad-keys"></ms-numpad-keys>
</div>
